import { Wallet } from '../../../../providers/DonorProvider/interfaces';
import { axiosClient } from '../../../../utils/axiosClient';
import { makeApiRequest } from '../../../../utils/makeApiRequest';

export interface FailedDonationResponse {
  gift: {
    uuid: string;
    txnId: number;
    receiptNumber: null;
    recurringId: number;
    accountType: Wallet['type'];
    maskedPan: string; // 'XXXXXXXXXXXX2222'
    amount: number;
    coveredFeeAmount: number | null;
    approvalCode: string;
    date: string; // 'May 17 2023 @ 1:15 PM EDT'
    isoDate: string;
  };
  memos: [];
  donee: {
    id: string; // '1071226100775949'
    name: string;
    address: string;
    canAcceptDonation: boolean;
  };
  envelopes: {
    id: number;
    name: string;
    amount: number;
  }[];
}

const GET_FAILED_DONATION_URL = (donationId: string) =>
  `/donor/profile/gift-by-uuid/${donationId}`;

export const getFailedDonationRequest = (donationId: string) => {
  const httpRequest = axiosClient.get(GET_FAILED_DONATION_URL(donationId));
  return makeApiRequest<FailedDonationResponse>(httpRequest);
};
